import React from "react";
import Layout from "../layouts/Layout";
import Hero from "../components/about-us/Hero";
import FeatureCards from "../components/about-us/FeatureCards";
import AwardsSection from "../components/about-us/AwardsSection";
import MissionVisionSection from "../components/about-us/MissionVisionSection";
import StrategicPartnershipsSection from "../components/about-us/StrategicPartnershipsSection";
import CoreTeamSection from "../components/about-us/CoreTeamSection";
import SupportingTeamsSection from "../components/about-us/SupportingTeamsSection";

const AboutUs = () => {
  return (
    <Layout>
      <Hero />

      <FeatureCards />
      <AwardsSection />
      <MissionVisionSection />
      <StrategicPartnershipsSection />
      <CoreTeamSection />
      <SupportingTeamsSection />
    </Layout>
  );
};

export default AboutUs;
